export default __webpack_public_path__ + "static/media/linxdot-logo-name-2.997c656e.png";